import { render, staticRenderFns } from "./reply-to-ghiab.vue?vue&type=template&id=77421c3a&"
import script from "./reply-to-ghiab.vue?vue&type=script&lang=js&"
export * from "./reply-to-ghiab.vue?vue&type=script&lang=js&"
import style0 from "./reply-to-ghiab.vue?vue&type=style&index=0&id=77421c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports